import { isEmpty } from "lodash"
import { KdsStorageKeys, useKdsStorage, useSessaoAtual, useToastSaurus } from "../../../../../../services/app"
import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { useGetProcessoProdutoSetor } from "../../../../../../data/api/gestao/processo-produto-setor/get-processo-produto-setor"
import { useGetProcessoSetor } from "../../../../../../data/api/gestao/processo-setor/get-processo-setor"
import { ProcessoProdutoSetorModel } from "../../../../../../model/api/processo-produto-setor/processo-produto-setor-model"
import { ProcessoSetorModel } from "../../../../../../model/api/processo-setor/processo-setor-model"
import { useHistory } from "react-router-dom"
import { CircularLoading } from "../../../../../components"
import { Grid, Typography } from "@material-ui/core"
import { ConcluidosCanceladosProcessosList } from "../concluidos-cancelados-processos-list/concluidos-cancelados-processos-list"
import { useStyles } from "./concluidos-cancelados-setores-list-styles"

export const ConcluidosCanceladosSetoresList = () => {

    //PROVIDERS
    const history = useHistory()
    const { showToast } = useToastSaurus()
    const { getRegistro } = useKdsStorage()
    const { getEmpresaSelecionada } = useSessaoAtual()
    const setoresStorage = getRegistro(KdsStorageKeys.ProcessosSetores, false) as ProcessoSetorModel[]
    const setoresLocalStorage: ProcessoSetorModel[] = useMemo(() => isEmpty(setoresStorage) ? [] : setoresStorage, [setoresStorage])

    //CHAMADAS DA API
    const { getProcessoProdutoSetor, carregando: carregandoProcessoProdutoSetor } = useGetProcessoProdutoSetor();
    const { getProcessoSetor, carregando: carregandoGetProcessoSetor } = useGetProcessoSetor()

    const carregando = carregandoGetProcessoSetor || carregandoProcessoProdutoSetor;

    const classes = useStyles()

    //STATES E REFS
    const carregouRef = useRef<boolean>(false)
    const [produtos, setProdutos] = useState<Array<ProcessoProdutoSetorModel>>([])
    const [setores, setSetores] = useState<ProcessoSetorModel[]>([])

    const getProcessoSetorWrapper = useCallback(async () => {
        const res = await getProcessoSetor(getEmpresaSelecionada()?.Id!);

        if (res.erro) throw res.erro

        return setSetores(res.resultado?.data.list)
    }, [getEmpresaSelecionada, getProcessoSetor])

    useEffect(() => {
        if (isEmpty(setoresLocalStorage)) {
            history.push('/selecionar-setor')
            showToast('info', 'Selecione os setores para visualizar a página.')
        }
    }, [history, setores, setoresLocalStorage, setoresLocalStorage.length, showToast])

    const getProcessoProdutoSetorWrapper = useCallback(async () => {
        try {
            const query = setores.map(item => item.processos.filter(item => item.processoProducao >= 9000).map(item => `${item.id};`).toString().replaceAll(',', ''))
            const queryString = '&processosIds=' + query.map(item => item).toString().replaceAll(',', '')
            const res = await getProcessoProdutoSetor(getEmpresaSelecionada()?.Id ?? '', queryString + '&pageSize=10000')

            if (res.erro) throw res.erro

            setProdutos(res.resultado?.data.list as ProcessoProdutoSetorModel[])

        } catch (e: any) {
            showToast('error', e.message)
        }
    }, [getEmpresaSelecionada, getProcessoProdutoSetor, setores, showToast])

    useEffect(() => {
        if (!carregouRef.current) {
            getProcessoProdutoSetorWrapper()
            getProcessoSetorWrapper();
        }
        carregouRef.current = true
    }, [getProcessoProdutoSetorWrapper, getProcessoSetorWrapper])


    useEffect(() => {
        const interval = setInterval(() => {
            getProcessoProdutoSetorWrapper();
        }, 30000)

        return () => clearInterval(interval)
    }, [getProcessoProdutoSetorWrapper, getProcessoSetorWrapper])

    return (
        <Grid container className={classes.spacing}>
            {carregando && (
                <div className={classes.loading}>
                    <CircularLoading tipo="FULLSIZED" />
                </div>
            )}
            {setoresLocalStorage.map((setor) => {

                const ids = setores.filter(x => x.setor.id === setor.setor.id);
                const produtosSetor = produtos.filter(item => ids.filter(x => x.setor.id === item.setorId)).filter(i => i.processoProducaoAtual >= 9000)

                const processos = setores?.filter(x => x.setor.id === setor.setor.id)[0]?.processos

                const concluidosCancelados = processos?.filter(x => x.processoProducao >= 9000)

                return (
                    <>
                        <Grid item xs={12}>
                            <Typography className={classes.title}>
                                {setor?.setor.descricao}
                            </Typography>
                            <div className={classes.divider} />
                            <Grid container spacing={2}>
                                <ConcluidosCanceladosProcessosList
                                    getProcessoProdutoSetorWrapper={getProcessoProdutoSetorWrapper}
                                    processos={concluidosCancelados}
                                    produtosSetor={produtosSetor}
                                />
                            </Grid>
                        </Grid>
                    </>
                )
            })}
        </Grid>
    )
}